class UrgentCareBanner {
    private banner: HTMLElement | null;
    private readonly isHomepage: boolean;

    constructor() {
        this.banner = document.querySelector('.urgent-care-banner');
        this.isHomepage = document.body.classList.contains('home');
        
        if (this.banner) {
            this.init();
        }
    }

    private init(): void {
        // Check for notifications regardless of page type
        const notificationsContainer = document.querySelector('.wp-block-plaudit-notifications-renderer');
        if (!notificationsContainer) {
            // No notifications, banner will be shown via CSS
            this.banner?.classList.add('urgent-care-banner--ready');
            return;
        }

        // Check if there are any active notifications
        const activeNotifications = notificationsContainer.querySelectorAll('.notification');
        if (activeNotifications.length === 0) {
            // No active notifications, banner will be shown via CSS
            this.banner?.classList.add('urgent-care-banner--ready');
            return;
        }

        // Add class to indicate there are other notifications
        this.banner?.classList.add('urgent-care-banner--has-notifications');

        // Only proceed with moving the banner if we're on the homepage
        if (!this.isHomepage || !this.banner) {
            this.banner?.classList.add('urgent-care-banner--ready');
            return;
        }

        // Find the post heading to insert the banner after
        const postHeading = document.querySelector('.acf-post-heading');
        if (postHeading) {
            // Move the banner after the post heading
            postHeading.after(this.banner);
            this.banner.classList.add('urgent-care-banner--below-masthead');
            document.body.classList.add('has-moved-urgent-care-banner');
        }
        
        // Add ready class after all operations are complete
        this.banner?.classList.add('urgent-care-banner--ready');
    }
}

// Initialize the banner
document.addEventListener('DOMContentLoaded', () => {
    new UrgentCareBanner();
});

export default UrgentCareBanner; 
